module.exports = __webpack_public_path__ + "img/0fb63aa.png";